import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const deleteClientApi = async (client_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.delete(`${BASEURL}/client/delete-client`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { client_id },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const createClientApi = async (user_id, domain_id, data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/client/create-client`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_id, domain_id },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllClientByDomainIdApi = async (domain_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-all-client-by-domainId`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { domain_id },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getClientByUserGroup = async (user_group) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-client-by-user-group`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_group },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getClientByUserGroupAndDomainIdApi = async (
  domain_id,
  page,
  size,
  search = '',
  status = ''
) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));

    return await axios.get(`${BASEURL}/client/get-client-by-userGroup-and-domainId`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: {
        domain_id,
        page,
        size,
        clientName: search || null,
        status: status || null,
      },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};


export const getAllPaginatedClientsApi = async ({clientName, domainName, status,page = 0, size = 5}) => {
  try {
    const payload = {
      client_name : clientName,
      domain_name : domainName,
      status,
      page,
      size
    }
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-paginated-clients`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: payload,
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllFavourites = async ({clientName, domainName,page = 0, size = 5}) => {
  try {
    const payload = {
      client_name : clientName,
      domain_name : domainName,
      page,
      size
    }
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-all-fav`, {
      headers: { Authorization: `Bearer ${parseToken}`},
      params : payload
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const addClientToFavourite = async (client_id) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.put(
      `${BASEURL}/client/add-to-fav`,
      { clientId: client_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error adding favorite:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const removeClientFromFavourite = async (client_id) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.put(
      `${BASEURL}/client/remove-from-fav`,
      { clientId: client_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error removing favorite:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllClientsApi = async () => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-all-client`, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getPendingClientApi = async (page = 0, size = 5) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/get-pending-client`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: {page, size}
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const approveClientApi = async (client_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/approve-client`, {
      params: { client_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const rejectClientApi = async (client_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/client/reject-client`, {
      params: { client_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
